export default "__VITE_ASSET__BuZpusiL__"